export default "icons-cart-outline"